import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { NotificationSettings } from '../../../../SideBar/SettingsModal/NotificationSettings';
import { SETTING_ICONS } from '../../../constants';
import './NotificationsSection.scss';

const NotificationsSection: FC = () => {
  const Icon = SETTING_ICONS.bell;
  const { t } = useTranslation();

  return (
    <div className="notifications-section notifications-section--new-tabs">
      <div className="notifications-section__block">
        <Stack gap={1} direction="row" alignItems="center">
          <Icon className="notifications-section__section-icon" />
          <Typography variant="body1" className="notifications-section__section-title">
            {t('settings.general.notifications')}
          </Typography>
        </Stack>
        <NotificationSettings />
      </div>
    </div>
  );
};

export default NotificationsSection;
